import React, { Fragment, } from 'react'
import { Button, Modal } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import './css/ModalCreateNewChannel.css'
interface ModalShowContentOCRProps {
  isOpen: boolean
  onClose: Function
  ocrData: string
}

const ModalShowContentOCR = ({
  isOpen,
  onClose,
  ocrData
}: ModalShowContentOCRProps) => {
  const { t } = useTranslation()

  return (
    <Fragment>
      <Modal
        open={isOpen}
        dimmer={{ className: 'test-dimmer' }}
        size={'tiny'}
        closeOnDimmerClick={false}
        className='create-new-modal'
      >
        <div className="header-color-line"></div>
        <Modal.Content>
          <div className='random--code'>
            <div className='random--code-title'>
              {t("OCR_Detected_title")}
            </div>
            <div className='random--code-content'>
              <a>{ocrData}</a>
            </div>
            <Button
              primary
              className="random--code-connect"
              onClick={() => onClose()}
            >
              {t('Close_panel')}
            </Button>
          </div>
        </Modal.Content>
      </Modal>
    </Fragment>
  )
}

export default ModalShowContentOCR
